import React, { ReactElement } from "react";
import { CSVLink } from "react-csv";
import { XtdByGroupRecord } from "../../../redux/types/reportTypes";
import { FileExcelOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const headers = [
  {
    label: "Cluster",
    key: "cluster",
  },
  {
    label: "MANAGER",
    key: "manager",
  },
  {
    label: "ORIGAMI",
    key: "origami",
  },
  {
    label: "LWTD",
    key: "lwtd",
  },
  {
    label: "WTD",
    key: "wtd",
  },
  {
    label: "WTD DIFF",
    key: "wtd_diff",
  },
  {
    label: "WTD % DIFF",
    key: "wtd_perc_diff",
  },
  {
    label: "LMTD",
    key: "lmtd",
  },
  {
    label: "MTD",
    key: "mtd",
  },
  {
    label: "MTD DIFF",
    key: "mtd_diff",
  },
  {
    label: "MTD % DIFF",
    key: "mtd_perc_diff",
  },
  {
    label: "LQTD",
    key: "lqtd",
  },
  {
    label: "QTD",
    key: "qtd",
  },
  {
    label: "QTD DIFF",
    key: "qtd_diff",
  },
  {
    label: "QTD % DIFF",
    key: "qtd_perc_diff",
  },
];

type GroupCSVProps = {
  data: Array<XtdByGroupRecord>;
};

const GroupCSV = ({ data }: GroupCSVProps): ReactElement => (
  <CSVLink data={data} headers={headers}>
    <Button type="dashed" icon={<FileExcelOutlined />} />
  </CSVLink>
);

export default GroupCSV;
